<template>
  <v-container fluid grid-list-md>
    <PageHeader no-padding />
    <v-layout wrap>
      <DataChecking v-for="(item, i) in checkingData" :key="i" :checkingMessage="item.checkingMessage" :checkingNum="item.checkingNum" :routerLink="item.routerLink" :linkMessage="item.linkMessage" v-model="checkingModel" :checkingArr="item.checkingArr" />
      <DataChecking :checkingMessage="checkingCofactorMessage" :checkingNum="checkingCofactorNum" :routerLink="{ name: 'analytesManageError', props: {name: currentUserGroup.name } }" />
    </v-layout>

    <Subheader v-model="search" title="Analyte List" search="Analyte List:">
      <v-btn style="float: right;" color="success" dark @click="addAnalyte()">
        <v-icon class="mr-1">add</v-icon>{{ $t('Button.Add_Analyte') }}
      </v-btn>
    </Subheader>
    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="MasterAnalyteList" :pagination.sync="pagination" :search="search">
          <template v-slot:items="props">
            <td class="text-xs-left keep_space">{{props.item.DisplayName}}</td>
            <td class="text-xs-left keep_space">{{props.item.AnalyteName}}</td>
            <td class="text-xs-right">
              <v-btn small :to="{ name: 'AnalyteDetailManage', params: { analyteId: props.item.Id.toString() } }">
                <!-- <v-icon class="mr-1" color="info">visibility</v-icon> -->
                {{ $t('Button.View') }}
              </v-btn>
              <v-btn small @click="deleteAnalyte(props.item)">
                <v-icon class="mr-1" color="error">delete_forever</v-icon>
                {{ $t('Button.Remove') }}
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addDialog" persistent max-width="800">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Add Analyte</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="addDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 pl-3 pr-3>
              <v-text-field label="AnalyteName:" v-model="newAnalyte.AnalyteName"></v-text-field>
              <v-text-field label="DisplayName:" v-model="newAnalyte.DisplayName"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="add" dark @click="save()">
            <v-icon class="mr-1">done</v-icon>{{ $t('Button.Save') }}
          </v-btn>
          <v-btn @click="closeDialog()">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delDialog" persistent max-width="800">
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title>Delete Analyte</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="delDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          {{ $t('AnalyteManage.titleMsg', { msg:deleteAnalyteName }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="delete" dark @click="agreeDelete()">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.DELETE_ANALYTE') }}
          </v-btn>
          <v-btn @click="delDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-snackbar :color="snackColor" :timeout="null" top v-model="snackbar" auto-height>
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>

  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import {
    splitArray,
  } from '@/helpers/arrays'
  import AnalyteUtil from '../mixins/AnalyteUtil'
  import DataChecking from '@/components/DataChecking'
  const analyte = createNamespacedHelpers('analyte')
  const unit = createNamespacedHelpers('unit')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    components: {
      PageHeader,
      Subheader,
      DataChecking,
    },
    mixins: [AnalyteUtil],
    data() {
      return {
        search: '',
        addDialog: false,
        delDialog: false,
        deleteAnalyteId: '',
        headers: [{
          text: 'Display Name',
          value: 'DisplayName',
          align: 'left',
        },
        {
          text: 'Envirodata Analyte Name',
          value: 'AnalyteName',
          align: 'left',
        },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'AnalyteName',
          rowsPerPage: 10,
        },
        newAnalyte: {},
        snackColor: '',
        snackMessage: '',
        deleteAnalyteName: '',
        snackbar: false,
        hasProblematicAnalyte: false,
        hasProblematicCofactor: false,
        checkingUnitMessage: '',
        checkingUnitNum: null,
        checkingCofactorMessage: '',
        checkingCofactorNum: null,
        checkingData: [],
        checkingModel: '',
      }
    },
    computed: {
      ...analyte.mapGetters(['tenantAnalyteList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...unit.mapGetters(['allUnitGroups', 'allUnits']),
      MasterAnalyteList() {
        return JSON.parse(JSON.stringify(this.tenantAnalyteList))
      },
    },
    mounted() {
      if (this.currentUserGroup.id || JSON.stringify(this.currentUserGroup) != '{}') {
        this.fetchAnalyteCheckingData()
      }
      if (!this.allUnits || !this.allUnits.length || !this.allUnitGroups || !this.allUnitGroups.length) {
        this.getUnitList()
        this.getUnitGroup()
      }
    },
    watch: {
      currentUserGroup() {
        this.fetchAnalyteCheckingData()
      },
      '$route': 'fetchAnalyteCheckingData',
    },
    methods: {
      ...analyte.mapActions(['addTenantAnalyte', 'deleteTenantAnalyte', 'analyteChecking']),
      ...unit.mapActions(['getUnitList', 'getUnitGroup']),
      save() {
        let analyteNames = []
        let displayNames = []
        this.MasterAnalyteList.forEach(e => {
          analyteNames.push(e.AnalyteName)
          displayNames.push(e.DisplayName)
        })
        analyteNames = Array.from(new Set(analyteNames))
        displayNames = Array.from(new Set(displayNames))
        let repeat = false
        if (this.newAnalyte.AnalyteName) {
          repeat = analyteNames.some(x => x == this.newAnalyte.AnalyteName) || displayNames.some(x => x == this
            .newAnalyte.DisplayName)
          if (repeat) {
            this.enableSnackbar('info', this.$t('AnalyteManage.repeatMsg'))
          } else {
            var options = {
              data: {
                AnalyteName: this.newAnalyte.AnalyteName,
                DisplayName: this.newAnalyte.DisplayName,
                TenantId: this.currentUserGroup.id,
              },
              successCb: () => {
                this.enableSnackbar('success', this.$t('AnalyteManage.successSaveMsg', {
                  msg: this.newAnalyte.AnalyteName,
                }))
                this.closeDialog()
              },
              failedCb: err => {
                this.enableSnackbar('error', err)
              },
            }
            this.addTenantAnalyte(options)
          }
        } else {
          this.enableSnackbar('info', this.$t('AnalyteManage.nullMsg'))
        }
      },
      addAnalyte() {
        this.addDialog = true
      },
      closeDialog() {
        this.addDialog = false
        this.newAnalyte = {}
        this.delDialog = false
      },
      deleteAnalyte(data) {
        this.deleteAnalyteId = data.Id
        this.delDialog = true
        this.deleteAnalyteName = data.AnalyteName
      },
      agreeDelete() {
        var options = {
          data: this.deleteAnalyteId,
          successCb: () => {
            this.enableSnackbar('success', this.$t('AnalyteManage.successDeleteMsg'))
            this.closeDialog()
          },
          failedCb: err => {
            this.enableSnackbar('error', err)
          },
        }
        this.deleteTenantAnalyte(options)
      },
      enableSnackbar(color, message) {
        this.snackbar = true
        this.snackColor = color
        this.snackMessage = message
      },
      fetchAnalyteCheckingData() {
        let options = {
          data: {
            TenantId: this.currentUserGroup.id,
          },
          success: (res) => {
            this.analyteCheckingCategory(res)
          },
          fail: () => {},
        }
        this.analyteChecking(options)
      },
      analyteCheckingCategory(data) {
        if (data.AnalyteNoAlias && data.AnalyteNoAlias.length) {
          this.checkingData.push({
            checkingMessage: this.$t('AnalyteManage.analyteWithoutAliasCheckingMsg'),
            checkingNum: data.AnalyteNoAlias.length.toString(),
            routerLink: { name: 'analytesManageError', props: { name: this.currentUserGroup.name } },
          })
        }
        if (data.AnalyteNoApplicableUnitGroup && data.AnalyteNoApplicableUnitGroup.length) {
          this.checkingData.push({
            checkingMessage: this.$t('AnalyteManage.analyteWithoutDefaultUnitGroupCheckingMsg'),
            checkingNum: data.AnalyteNoApplicableUnitGroup.length.toString(),
            routerLink: { name: 'analytesManageError', props: { name: this.currentUserGroup.name } },
          })
        }
        if (data.AnalyteNoDefaultUnit && data.AnalyteNoDefaultUnit.length) {
          this.checkingData.push({
            checkingMessage: this.$t('AnalyteManage.analyteWithoutDefaultUnitCheckingMsg'),
            checkingNum: data.AnalyteNoDefaultUnit.length.toString(),
            routerLink: { name: 'analytesManageError', props: { name: this.currentUserGroup.name } },
          })
        }
        if (data.AnalyteUnitNotMatchUnitGroup && data.AnalyteUnitNotMatchUnitGroup.length) {
          this.checkingData.push({
            checkingMessage: this.$t('AnalyteManage.analyteUnitNotMatchUnitGroupCheckingMsg'),
            checkingNum: data.AnalyteUnitNotMatchUnitGroup.length.toString(),
            routerLink: { name: 'analytesManageError', props: { name: this.currentUserGroup.name } },
          })
        }
        if (data.AnalyteGuidelineLinkHaveMismatchedUnitGroup && data.AnalyteGuidelineLinkHaveMismatchedUnitGroup.length) {
          this.checkingData.push({
            checkingMessage: this.$t('AnalyteManage.analyteGuidelineLinkHaveMismatchedUnitGroupCheckingMsg'),
            checkingNum: data.AnalyteGuidelineLinkHaveMismatchedUnitGroup.length.toString(),
            checkingArr: splitArray(data.AnalyteGuidelineLinkHaveMismatchedUnitGroup.map(x => x.GuidelineShortName + '_' + x.StandardAnalyteName + ' - ' + x.EnviroDataAnalyteName),1),
            routerLink: { name: 'analytesManageError', props: { name: this.currentUserGroup.name } },
          })
        }
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .keep_space {
    white-space: pre;
  }

  .card_text_right {
    text-align: right;
  }

  .pl {
    padding-left: 3px;
  }

  .text_grey {
    color: grey;
  }

  .b_r_15 {
    border-radius: 15% !important;
  }

  .top_20 {
    position: relative;
    top: -20px;
  }
</style>